import { Component, OnInit } from '@angular/core'
import { StoreService } from 'app/service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { Router } from '@angular/router'
import { CpmService } from '../../service/cpm.service'
import { ActivatedRoute } from '@angular/router'
@Component({
  selector: 'app-trading-statistic',
  templateUrl: './trading-statistic.component.html',
  styleUrls: ['./trading-statistic.component.scss']
})
export class TradingStatisticComponent implements OnInit {
  subscription: Subscription
  subscriptionPeriod: Subscription
  period = 'YTD'
  symbol
  listSecurityTrading = []
  tradingHeader = [
    'Symbol',
    'Price (Baht) ',
    'Volume/Day (M.shares)',
    'Value/Day (M.Baht)',
    'Market cap (M.Baht) ',
    'Turnover ratio (%)',
    'P/E (x)'
  ]
  constructor(
    private store: StoreService,
    private cpmService: CpmService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    const { symbol } = this.activatedRoute.snapshot.params
    const { period } = this.activatedRoute.snapshot.params

    // tslint:disable-next-line:no-unused-expression
    symbol !== undefined ? (this.symbol = symbol) : null
    // tslint:disable-next-line:no-unused-expression
    // period !== undefined ? (this.period = period) : null

    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.symbol = response['securitySymbol']
        if (period !== undefined) {
          this.getListSecurityTrading(this.symbol, period)
        } else {
          this.getListSecurityTrading(this.symbol, this.period)
        }
      })

    this.subscriptionPeriod = this.store
      .getPeriodInputObservable()
      .subscribe(newPeriodInput => {
        if (newPeriodInput !== undefined) {
          if (period !== undefined) {
            this.getListSecurityTrading(this.symbol, period)
          } else {
            this.getListSecurityTrading(this.symbol, newPeriodInput)
          }
        }
      })
  }

  getListSecurityTrading(symbol, period) {
    if (symbol.toString().length > 0) {
      this.listSecurityTrading = []
      this.cpmService.getSecurityTrading(symbol, period).then(
        tradings => {
          this.listSecurityTrading = tradings
          const avgTradingValues = []
          const avgTradingVolumes = []
          const marketCaps = []
          const pbvs = []
          const pes = []
          const lastPriceClose = []
          const turnoverRatios = []
          this.listSecurityTrading.map(ltrading => {
            avgTradingValues.push(ltrading.avgTradingValue)
            avgTradingVolumes.push(ltrading.avgTradingVolume)
            marketCaps.push(ltrading.marketCap)
            pbvs.push(ltrading.pbv)
            pes.push(ltrading.pe)
            lastPriceClose.push(ltrading.lastPriceClose)
            turnoverRatios.push(ltrading.turnoverRatio)
          })
          this.listSecurityTrading.push({
            securityIdPsims: null,
            securitySymbol: 'Total',
            lastPriceClose: null,
            pe: null,
            pbv: null,
            marketCap: marketCaps.reduce(function (a, b) {
              return a + b
            }, 0),
            turnoverRatio: null,
            sectorName: null,
            marketName: null,
            avgTradingVolume: avgTradingVolumes.reduce(function (a, b) {
              return a + b
            }, 0),
            avgTradingValue: avgTradingValues.reduce(function (a, b) {
              return a + b
            }, 0)
          })
        },
        err => { console.log('err -', err) }
      )
    }
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/trading-statistic/trading-statistic.component.ts